/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Cookies_AnalyticsInputs */

const en_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics (PostHog): `)
};

const de_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse (PostHog): `)
};

const fr_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses (PostHog) : `)
};

const es_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis (PostHog): `)
};

const it_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi (PostHog): `)
};

const nl_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytisch (PostHog): `)
};

const pl_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analityka (PostHog): `)
};

const fi_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytiikka (PostHog): `)
};

const da_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse (PostHog): `)
};

const sv_privacy_cookies_analytics = /** @type {(inputs: Privacy_Cookies_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analys (PostHog): `)
};

/**
* | output |
* | --- |
* | "Analytics (PostHog):" |
*
* @param {Privacy_Cookies_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_cookies_analytics = /** @type {((inputs?: Privacy_Cookies_AnalyticsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Cookies_AnalyticsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_cookies_analytics(inputs)
	if (locale === "fr") return fr_privacy_cookies_analytics(inputs)
	if (locale === "es") return es_privacy_cookies_analytics(inputs)
	if (locale === "it") return it_privacy_cookies_analytics(inputs)
	if (locale === "nl") return nl_privacy_cookies_analytics(inputs)
	if (locale === "pl") return pl_privacy_cookies_analytics(inputs)
	if (locale === "fi") return fi_privacy_cookies_analytics(inputs)
	if (locale === "da") return da_privacy_cookies_analytics(inputs)
	if (locale === "sv") return sv_privacy_cookies_analytics(inputs)
	return en_privacy_cookies_analytics(inputs)
});